import { render, staticRenderFns } from "./VehiculeContraventions.vue?vue&type=template&id=a915dee4&scoped=true&"
import script from "./VehiculeContraventions.vue?vue&type=script&lang=js&"
export * from "./VehiculeContraventions.vue?vue&type=script&lang=js&"
import style0 from "./VehiculeContraventions.vue?vue&type=style&index=0&id=a915dee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a915dee4",
  null
  
)

export default component.exports